// 初期表示アニメーション用のCSS
export const animationStyles = `
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  @keyframes fadeInScale {
    from { 
      opacity: 0;
      transform: scale(1.05) translateY(20px);
    }
    to { 
      opacity: 1;
      transform: scale(1) translateY(0);
    }
  }

  @keyframes pulse {
    0% {
      box-shadow: 0 0 0 0 rgba(var(--primary-rgb), 0.4);
    }
    70% {
      box-shadow: 0 0 0 10px rgba(var(--primary-rgb), 0);
    }
    100% {
      box-shadow: 0 0 0 0 rgba(var(--primary-rgb), 0);
    }
  }


  .fade-in {
    animation: fadeIn 0.5s ease-in forwards;
  }

  .fade-in-scale {
    animation: fadeInScale 1.2s cubic-bezier(0.4, 0, 0.2, 1) forwards;
  }

  .pulse-animation {
    animation: pulse 2s infinite;
  }


  .tab-content-enter {
    opacity: 0;
    transform: translateY(10px);
  }

  .tab-content-enter-active {
    opacity: 1;
    transform: translateY(0);
    transition: opacity 0.3s, transform 0.3s;
  }

  .tab-content-exit {
    opacity: 1;
  }

  .tab-content-exit-active {
    opacity: 0;
    transition: opacity 0.3s;
  }

  .expanded-drop-area {
    min-height: 200px; /* ドロップエリアを拡大 */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    transition: all 0.3s ease;
  }

  .expanded-drop-area:hover {
    transform: scale(1.01);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
`; 